import _ from 'lodash'
import ProfileSnapshot from './profile-summary/profile-snapshot'
import LegalDisclaimerMarketConduct from 'quick-quote/product-common/benefit-illustration/components/legal-disclaimer-market-conduct'
import RiderBenefits from './rider-benefits'
import { SidebarMenu } from 'quick-quote/components'
import { isNil } from 'core/service/lib/type-check'
import { FormFeedback, FormGroup } from 'reactstrap'
import PolicyValueTable from './policy-value/policy-value-table'
import { Redirect } from 'react-router-dom'
import PATH from 'quick-quote/constants/path'
import MESSAGES from 'core/data-model/constants/validation-messages'
import BIMESSAGES from 'core/data-model/constants/bi-messages'

export const summaryHeaderWithCode = ({ displayProduct, riders }) => {
  const name = _.get(displayProduct, 'displayName', '')
  return `${name}`
}

const summaryHeader = ({ displayProduct }) => (displayProduct ? displayProduct.displayName : '')

const BenefitIllustration = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  sumAssured$,
  basicPremium$,
  totalPremium,
  totalRiderPremium,
  selectedModelFactorLabel,
  hasNonLevelRider,
  coveragePlanStartDate,
  legalDisclaimerEndDate,
  policyValue,
  benefitSummary,
  canProceedToBenefitIllustration,
  isBlockedPdfGeneration,
  isBlockedEnteringESub,
  isReviseQQ,
}) => {
  if (!canProceedToBenefitIllustration) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  } else if (isNil(displayProduct)) return <div id="benefit-illustration-invalid" />
  else {
    return (
      <div id="benefit-illustration">
        <div className="content">
          <ProfileSnapshot
            displayProduct={displayProduct}
            riders={riders}
            genderLabel={genderLabel}
            age={age}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            policyValue={policyValue}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            totalPremium={totalPremium}
            totalRiderPremium={totalRiderPremium}
            selectedModelFactorLabel={selectedModelFactorLabel}
            hasNonLevelRider={hasNonLevelRider}
            profileSummaryHeader={summaryHeaderWithCode}
            summaryTableHeader={summaryHeader}
            isReviseQQ={isReviseQQ}
          />

          {riders.length > 0 && <RiderBenefits />}

          <PolicyValueTable policyValue={policyValue} basicPlan={displayProduct} />

          <LegalDisclaimerMarketConduct startDate={coveragePlanStartDate} endDate={legalDisclaimerEndDate} />

          {isBlockedEnteringESub ? (
            <FormGroup className="has-warning">
              <FormFeedback className={'eligibility-message attached-icon'}>
                <div> {MESSAGES.RULE_ENTER_ESUB_PREREQUISITE} </div>
              </FormFeedback>
            </FormGroup>
          ) : (
            ''
          )}
        </div>
        <SidebarMenu
          mainMenu={[
            {
              text: BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS,
              id: 'profile-summary',
              isSub: false,
            },
            {
              text: BIMESSAGES.RIDERS_BENEFITS_IGROW,
              id: 'riders-benefit',
              isSub: false,
            },
            {
              text: BIMESSAGES.POLICY_VALUE_TABLE,
              id: 'policy-value',
              isSub: false,
            },
            {
              text: BIMESSAGES.LEGAL_DISCLAIMER,
              id: 'legal-disclaimer-market-conduct',
              isSub: false,
            },
          ]}
        />
      </div>
    )
  }
}

export default BenefitIllustration
